import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'app-qoh-popover-panel',
	standalone: true,
	imports: [CommonModule],
	template: `
		<div class="qoh-popover" [ngStyle]="style">
			<ng-container *ngIf="rows.length">
				<div class="qoh-popover__title" *ngIf="showTotal">QOH by location</div>
				<div class="qoh-popover__rows">
					<div *ngFor="let row of rows" class="qoh-popover__row">
						<span class="qoh-popover-pill qoh-popover-pill--location">{{ row.name }}</span>
						<span class="qoh-popover-pill qoh-popover-pill--qty" [ngClass]="getQohPillClass(row.qty)">{{ row.qty }}</span>
					</div>
					<div *ngIf="showTotal" class="qoh-popover__row qoh-popover__total">
						<span class="qoh-popover-pill qoh-popover-pill--location">Total</span>
						<span class="qoh-popover-pill qoh-popover-pill--qty qoh-popover-pill--green">{{ total }}</span>
					</div>
				</div>
			</ng-container>
			<div *ngIf="!rows.length && total != null" class="qoh-popover__fallback">
				<span class="qoh-popover-pill qoh-popover-pill--qty qoh-popover-pill--green">QOH {{ total }}</span>
			</div>
		</div>
	`,
	styles: [`
		.qoh-popover {
			position: fixed;
			z-index: 99999;
			min-width: 220px;
			max-width: 360px;
			background: #fff;
			border: 1px solid rgba(0,0,0,0.2);
			border-radius: 8px;
			box-shadow: 0 4px 12px rgba(0,0,0,0.2);
			padding: 10px 12px;
			pointer-events: none;
			color: #333;
		}
		.qoh-popover__title {
			font-weight: 600;
			font-size: 0.65rem;
			text-transform: uppercase;
			letter-spacing: 0.03em;
			color: #888;
			margin-bottom: 8px;
			padding-bottom: 4px;
			border-bottom: 1px solid rgba(0,0,0,0.08);
		}
		.qoh-popover__rows {
			display: flex;
			flex-direction: column;
			gap: 6px;
		}
		.qoh-popover__row {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 10px;
			font-size: 12px;
		}
		.qoh-popover__total {
			margin-top: 4px;
			padding-top: 6px;
			border-top: 1px solid rgba(0,0,0,0.12);
			font-weight: 600;
		}
		.qoh-popover-pill {
			display: inline-block;
			font-variant-numeric: tabular-nums;
			font-weight: 600;
			font-size: 0.75rem;
			padding: 3px 8px;
			border-radius: 10px;
			text-align: center;
		}
		.qoh-popover-pill--location {
			background-color: #f5f5f5;
			color: #555;
			border: 1px solid #e0e0e0;
			flex: 1;
			min-width: 0;
			text-align: left;
		}
		.qoh-popover-pill--qty {
			min-width: 2em;
			flex-shrink: 0;
		}
		.qoh-popover-pill--qty.qoh-popover-pill--red {
			background-color: #ffebee;
			color: #b71c1c;
			border: 1px solid #ef9a9a;
		}
		.qoh-popover-pill--qty.qoh-popover-pill--yellow {
			background-color: #fff8e1;
			color: #e65100;
			border: 1px solid #ffcc80;
		}
		.qoh-popover-pill--qty.qoh-popover-pill--green {
			background-color: #e8f5e9;
			color: #2e7d32;
			border: 1px solid #a5d6a7;
		}
		.qoh-popover__fallback {
			font-size: 12px;
		}
	`]
})
export class QohPopoverPanelComponent {
	@Input() item: { qoh?: any[]; canviewqoh?: number; locqoh?: number } | null = null;

	style: { [key: string]: string } = { visibility: 'hidden' };

	get total(): number {
		if (!this.item) return 0;
		return this.item.canviewqoh != null ? this.item.canviewqoh : (this.item.locqoh ?? 0);
	}

	get rows(): { name: string; qty: number }[] {
		if (!this.item?.qoh || !Array.isArray(this.item.qoh)) return [];
		return this.item.qoh.map((loc: any) => ({
			name: (loc.locationname || loc.loccode || loc.code || '?').trim(),
			qty: loc.quantity != null ? loc.quantity : 0
		}));
	}

	get showTotal(): boolean {
		return this.rows.length > 1;
	}

	getQohPillClass(qty: number): string {
		const n = qty != null ? Number(qty) : 0;
		if (n <= 0) return 'qoh-popover-pill--red';
		if (n < 4) return 'qoh-popover-pill--yellow';
		return 'qoh-popover-pill--green';
	}

	updatePosition(rect: DOMRect) {
		const gap = 8;
		const minSpaceAbove = 180;
		const openAbove = rect.top >= minSpaceAbove;
		if (openAbove) {
			this.style = {
				left: `${rect.left + rect.width / 2}px`,
				top: `${rect.top - gap}px`,
				transform: 'translate(-50%, -100%)'
			};
		} else {
			this.style = {
				left: `${rect.left + rect.width / 2}px`,
				top: `${rect.bottom + gap}px`,
				transform: 'translate(-50%, 0)'
			};
		}
	}
}
